const defaultEmployee = {
  address: "",
  all_cooperation: "",
  can_change_restoran_company: 0,
  children: "",
  code: "",
  company_delivery: [],
  email: "",
  external_code: null,
  image_path: null,
  is_contract: 1,
  is_non_contract: 0,
  is_transferable: 0,
  lastname: "",
  name: "",
  no_time_limit_user: 0,
  notification: null,
  password: "",
  phone: "",
  private_email: "",
  state: 1,
  team: null,
  workPos: "",
};



export { defaultEmployee };
